export const QUERY_KEYS = {
    PACKAGE: "package"
};
